import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';
import { QRCode } from 'react-qrcode-logo';
import { Button, TextField } from '@mui/material';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { RefObject } from 'react';

export default function GenerateQRCode() {
  const [value, setValue] = React.useState("https://datawhispers.idea4industry.com");
  const ref = React.useRef<QRCode>(null);

  const handleDownload = () => {
    ref.current?.download('png', 'data-whispers-qr-code.png');
  };

  return (
    <Card sx={{ maxWidth: '40%', padding: 2}}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: '#db5f14', color: 'white' }} aria-label="recipe">
            <QrCode2Icon />
          </Avatar>
        }
       
        title="QR Code"
        slotProps={{
            title: {
                sx: {
                    fontWeight: 'bold',
                }
            }
        }}
        subheader="You can generate and download the QR Code for your IDEA Data Whispers"
      />
      <QRCode
            enableCORS={true}
            ref={ref as RefObject<QRCode>}
            size={256}
            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
            value={value}
            removeQrCodeBehindLogo={true}
            logoOpacity={0.8}
            logoImage="https://idea4industry.com/wp-content/uploads/cropped-IDEA-favicon-192x192.png"
            ecLevel="H"
            logoPaddingStyle="square"
            logoOnLoad={() => {
            }}
            // Removed ref={qrCodeRef} to fix type error
        />
      <CardContent>
        <TextField
          label="QR Code"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          fullWidth
        />
      </CardContent>
      <CardActions disableSpacing sx={{ justifyContent: 'center' }}>
        <Button variant="contained" disabled={!value} color="primary" onClick={handleDownload} style={{textTransform: 'none'}}>Download QR Code</Button>
      </CardActions>
    </Card>
  );
}
